import BasicRouterView from "../../components/BasicRouterView.vue";

const facialRoutes = {
  path: "facial",
  redirect: { name: "facial-cadastro" },
  meta: {
    label: "Facial",
    icon: "face",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "facial-cadastro",
      name: "facial-cadastro",
      meta: {
        label: "Cadastrar Face",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/CadastroFacial.vue"),
    },
    {
      path: "facial-listagem",
      name: "facial-listagem",
      meta: {
        label: "Exclusao Facial",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/ExclusaoFacial.vue"),
    },
    {
      path: "facial-verificar",
      name: "facial-verificar",
      meta: {
        label: "Verificar Face",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/VerificarFacial.vue"),
    },
    {
      path: "facial-identificar",
      name: "facial-identificar",
      meta: {
        label: "Identificar Face",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/IdentificacaoFacial.vue"),
    },
    {
      path: "facial-templates",
      name: "facial-templates",
      meta: {
        label: "Consultar Templates",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/ConsultarTemplates.vue"),
    },
  ],
};

export default facialRoutes;
